import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import {App} from 'ionic-angular';
import {OauthService} from './oauth.service';
import {ToolsService} from './tools.service';
import {Search} from '../models/search/search.model';
import {Observable} from 'rxjs/Observable';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class SubventionService extends OauthService {

  public loader = new Subject<boolean>();

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);

    this.loader.next(true); // init custom loader
  }

  getAllSubventionHistory(search: Observable<Search> = null) {
    return search.debounceTime(500)
      .distinctUntilChanged()
      .switchMap(s => this.searchAllSubventionHistory(s, s.action));
  }

  searchAllSubventionHistory(search: Search, action: string) {
    const param = {'_format': 'json'};

    for (const item in search) {
      if (search[item]) {
        param[item] = search[item];
      }
    }

    const url = this.Routing.generate('api_get_mouvement_subventions_historique', param, true);

    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        this.loader.next(false); // disable custom loader
        return {data: response.json().data, action};
      });
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/subvention.service.ts